module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl q-text-center\"> <span class=\"q-boldest q-block\">The serial number entered has been received for this BAN.</span> If you are completing this action to reprint labels/receipts, please go to the Return Lookup and reprint the labels/receipts. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fxoReceivingScreen/html/receiptExistForBanNo.html
// module id = 1322
// module chunks = 1